var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.showPageRecord ? 'pagination-wrap' : ''
  }, [_c('div', {
    staticClass: "css-controls"
  }, [_c('div', {
    staticClass: "page-size-select"
  }, [_c('label', {
    attrs: {
      "for": "pageSize"
    }
  }, [_vm._v("Rows per page:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedPageSize,
      expression: "selectedPageSize"
    }],
    attrs: {
      "id": "pageSize"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedPageSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.updatedPageSize]
    }
  }, _vm._l(_vm.pageSizes, function (size) {
    return _c('option', {
      key: size,
      domProps: {
        "value": size
      }
    }, [_vm._v(_vm._s(size))]);
  }), 0)]), _vm.from && _vm.to && _vm.total && _vm.showPageRecord ? _c('div', {
    staticClass: "page-record"
  }, [_c('span', [_vm._v("Showing " + _vm._s(_vm.from) + " to " + _vm._s(_vm.to) + " of " + _vm._s(_vm.total) + " results")])]) : _vm._e()]), _vm.total > _vm.perPage ? _c('div', {
    staticClass: "table-pagination"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.selectedPageSize,
      "align": "right",
      "prev-text": "Prev",
      "next-text": "Next",
      "first-text": "First",
      "last-text": "Last"
    },
    on: {
      "change": _vm.handlePageChange
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }